import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import moment from 'moment';

import { siteURL } from '../../config';
import { buildSourceURL } from '../../utils/functions';
import { getBlogById } from '../../actions/blogs';

import styles from './Blog.module.css';

const Blog = (props) => {
  const { blogData, getBlogById } = props;

  const { id: blogId } = useParams();

  useEffect(() => {
    getBlogById(blogId);
  }, []);

  if (!blogData) {
    return null;
  }

  const renderContent = (content) => {

    switch (content.type) {
      case 'text':
        return (
          <div 
            className={styles.contentText}
            dangerouslySetInnerHTML={{ __html: content.value }} 
          />
        );

      case 'image':
        return (
          <img 
            src={buildSourceURL(content.value)} 
            alt={content.title}
            className={styles.contentImage} 
          />
        );

      case 'video':
        return (
          <video controls className={styles.contentVideo}>
            <source src={buildSourceURL(content.value)} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.wrapper}>
      <Link to="/blog" className={styles.backButton} />
      <img
        className={styles.image}
        src={buildSourceURL(blogData.image)} 
        alt={blogData.title} 
      />
      <div className={styles.content}>
        <div className={styles.published}>
          Published on {moment(blogData.created_at).format('MMM DD, YYYY')}
        </div>
        <div className={styles.title}>
          {blogData.title}
        </div>
        <div className={styles.authorBlock}>
          <img
            className={styles.authorImage}
            src={buildSourceURL(blogData.author.image)} 
            alt={blogData.author.name} 
          />
          <div className={styles.authorInfo}>
            <div>Written by</div>
            <div className={styles.authorName}>
              {blogData.author.name}
            </div>
            <div>{blogData.author.profession}</div>          </div>
        </div>
        <div className={styles.share}>
          Share article: 
          <a 
            className={styles.facebookShare}
            href={`https://www.facebook.com/sharer/sharer.php?u=${siteURL}blog/${blogData.id}`} 
            target="_blank"
            rel="noopener noreferrer"
          />
          {/* <a 
            className={styles.instagramShare}
            href={`https://www.facebook.com/sharer/sharer.php?u=${siteURL}/blog/${blogData.id}`} 
            target="_blank"
            rel="noopener noreferrer"
          /> */}
        </div>
        <div className={styles.description}>
          {blogData.description}
        </div>
        <div className={styles.blogContent}>
          {blogData.contents.map(renderContent)}
        </div>
        <div className={styles.backButtonWrapper}>
          <Link to="/blog" className="green-button">
            Back
          </Link> 
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  blogData: state.blog.blogData,
});

const mapDispatchToProps = {
  getBlogById,
};

export default connect(mapStateToProps, mapDispatchToProps)(Blog);